import { render } from "./MyPurchases.vue?vue&type=template&id=e9267b8e&scoped=true"
import script from "./MyPurchases.vue?vue&type=script&lang=js"
export * from "./MyPurchases.vue?vue&type=script&lang=js"

import "./MyPurchases.vue?vue&type=style&index=0&id=e9267b8e&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/sb.web.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9267b8e"]])

export default __exports__